<button
  appButton
  [name]="name"
  [location]="location"
  [color]="color"
  spacing="full"
  [hasIcon]="!!icon || !!imageUrl"
  (click)="onClick.emit($event)"
  [height]="height"
  [class.disabled]="disabled"
  [shape]="shape"
  [weight]="weight"
  [spacing]="fullWidth ? 'full' : ''"
  [alignment]="fullWidth ? 'left' : 'center'"
  [class]="buttonClass"
  *ngIf="!routerLink"
>
  <ng-container *ngTemplateOutlet="buttonContent"></ng-container>
</button>

<a
  appButton
  [name]="name"
  [location]="location"
  [color]="color"
  spacing="full"
  [hasIcon]="!!icon || !!imageUrl || !!customIcon"
  [routerLink]="routerLink"
  [routerLinkActive]="routerLinkActive ?? ''"
  [routerLinkActiveOptions]="{ exact: true }"
  [height]="height"
  [class.disabled]="disabled"
  [shape]="shape"
  [weight]="weight"
  [spacing]="fullWidth ? 'full' : ''"
  [alignment]="fullWidth ? 'left' : 'center'"
  [class]="buttonClass"
  *ngIf="!!routerLink"
>
  <ng-container *ngTemplateOutlet="buttonContent"></ng-container>
</a>

<ng-template #buttonContent>
  <app-svg *ngIf="!!icon" [attr.color]="iconColor" src="/assets/icons/{{ icon }}.svg"></app-svg>
  <img [src]="imageUrl" [attr.loading]="imgLoading" *ngIf="imageUrl" alt="" />
  <div class="custom-svg" [innerHTML]="sanitization.bypassSecurityTrustHtml(customIcon)" *ngIf="customIcon"></div>
  <span class="button-span" [class.overflow-visible]="!!shortcut">
    <ng-content></ng-content>
    <ng-container *ngIf="shortcut">
      <div class="shortcut" *onlyForScreens="['desktop']">{{ shortcut }}</div>
    </ng-container>
  </span>
  <ng-content select="[post]"></ng-content>
</ng-template>
